var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOtpIco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 14C18 10.6 20.6 8 24 8C27.4 8 30 10.6 30 14V18H34V14C34 8.4 29.6 4 24 4C18.4 4 14 8.4 14 14V18H18V14ZM27 29C27 27.4 25.6 26 24 26C22.4 26 21 27.4 21 29C21 29.8 21.4 30.6 22 31.2V34C22 35.2 22.8 36 24 36C25.2 36 26 35.2 26 34V31.2C26.6 30.6 27 29.8 27 29Z",
    fill: "#9D1B21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 18H14C10.6 18 8 20.6 8 24V38C8 41.4 10.6 44 14 44H34C37.4 44 40 41.4 40 38V24C40 20.6 37.4 18 34 18ZM26 31.2V34C26 35.2 25.2 36 24 36C22.8 36 22 35.2 22 34V31.2C21.4 30.6 21 29.8 21 29C21 27.4 22.4 26 24 26C25.6 26 27 27.4 27 29C27 29.8 26.6 30.6 26 31.2Z",
    fill: "#EB2931"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtpIco);
export default __webpack_public_path__ + "static/media/otp_ico.4f2584b78e8713c37974344d09f69aaf.svg";
export { ForwardRef as ReactComponent };